import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { OfflineBookingMessageStatusUpdate, ChatMessages, OfflineBookingRequest, OfflineBookingRequestGet, OfflineBookingResponseGet, OfflineBookingRejection, OfflineBookingRequestObject, OfflineBookingSuppliersAccessCodeProperties } from '../Models/OfflineBookingRequestProperties';
import { catchError, map } from 'rxjs/operators';
import { OfflineBookingPassengerDetails, OfflineBookingWrapper } from '../Models/OfflineBookingProperties';
import { PassengerCreationResponse } from '../Models/BookingPassengerTicketIssuanceProperties';

@Injectable({
  providedIn: 'root'
})
export class OfflineBookingRequestService {
  baseUrl = environment.baseUrl;
  // backSystemBaseUrl = environment.backSystemBaseUrl;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }
 
  constructor(private httpRequest: HttpClient) { }
  private handleError(errors: HttpErrorResponse): Observable<any> {
    let errorMessage: string = '';
    if (errors.status === 0) {

      //console.error('An error occurred:', errors.error);
      errorMessage = errors.error;
    } else {
      // console.error(`:${errors.status}`,errors.error );
      errorMessage = `${errors.status}`;
    }
    errorMessage += '-Something Went Wrong! Please Try Again Later.'
    // Return an observable with a user-facing error message.
    return throwError(errorMessage);
  }
  OfflineBookingRequestCreate(offlineBooking: FormData): Observable<boolean> {
    return this.httpRequest.post<boolean>(this.baseUrl + '/OfflineBooking/OfflineBookingRequestCreate', offlineBooking).pipe(
      map((response) => {
        return response;
      }), catchError(this.handleError));
  }
  OfflineBookingRequestPassengerUpdate(offlineBookingRequestObject:OfflineBookingRequestObject ): Observable<boolean> {
    return this.httpRequest.post<boolean>(this.baseUrl + '/OfflineBooking/OfflineBookingRequestPassengerUpdate', offlineBookingRequestObject).pipe(
      map((response) => {
        return response;
      }), catchError(this.handleError));
  }
  OfflineBookingRequestGet(offlineBooking: OfflineBookingRequestGet): Observable<OfflineBookingResponseGet> {
    return this.httpRequest.post<OfflineBookingResponseGet>(this.baseUrl + '/OfflineBooking/OfflineBookingRequestGet', offlineBooking).pipe(
      map((response) => {
        return response;
      }), catchError(this.handleError));
  }
  ChatMessagesCommunication(chatForm: FormData): Observable<ChatMessages[]> {
    return this.httpRequest.post<ChatMessages[]>(this.baseUrl + '/OfflineBooking/ChatMessagesCommunication', chatForm).pipe(
      map((response) => {
        return response;
      }), catchError(this.handleError));
  }
  OfflineBookingRequestFileDownload(filePath: string, fileType: string): Observable<Blob> {
    return this.httpRequest.get(this.baseUrl + '/OfflineBooking/OfflineBookingRequestFileDownload?filePath=' + filePath + '&fileType=' + fileType, { responseType: 'blob' }).pipe(
      map((response: Blob) => {
        return response;
      }), catchError(this.handleError));
  }
  AcceptOfferConfirm(messageStatusUpdate: OfflineBookingMessageStatusUpdate): Observable<OfflineBookingResponseGet> {
    return this.httpRequest.post<OfflineBookingResponseGet>(this.baseUrl + '/OfflineBooking/OfflineBookingRequestStatusUpdate', messageStatusUpdate).pipe(
      map((response) => {
        return response;
      }), catchError(this.handleError));
  }
  // UpdateOffilneBookingPaasengerDetails(obj: OfflineBookingWrapper): Observable<boolean> {
  //   return this.httpRequest.post<boolean>(this.baseUrl + '/OfflineBooking/UpdateOffilneBookingPaasengerDetails', obj, this.httpOptions)
  //     .pipe(map((response) => {
  //       return response;
  //     }), catchError(this.handleError));
  // }

  IssueTicketOffilneBooking(obj: OfflineBookingWrapper): Observable<PassengerCreationResponse> {
    return this.httpRequest.post<boolean>(this.baseUrl + '/OfflineBooking/IssueTicketOffilneBooking', obj, this.httpOptions)
      .pipe(map((response) => {
        return response;
      }), catchError(this.handleError));
  }
  OffilneBookingRejectionCall(obj: OfflineBookingRejection): Observable<boolean> {
    return this.httpRequest.post<boolean>(this.baseUrl + '/OfflineBooking/OffilneBookingRejectionCall', obj, this.httpOptions)
      .pipe(map((response) => {
        return response;
      }), catchError(this.handleError));
  }
  GetOffliBookingRequestSupplierAccessCode(supplierId:string):Observable<OfflineBookingSuppliersAccessCodeProperties[]> {
    return this.httpRequest.get<OfflineBookingSuppliersAccessCodeProperties[]>(this.baseUrl + '/OfflineBooking/GetOffliBookingRequestSupplierAccessCode?supplierId='+supplierId).pipe(map((data) => {
      return data;
    }), catchError(this.handleError));
    //error => { return throwError(error)}
  }
  UpdateOfflineBookingRequestTag(offlineBookingRequestID:number,offlineBookingRequestStatus:number):Observable<boolean> {
    return this.httpRequest.get<boolean>(this.baseUrl + '/OfflineBooking/UpdateOfflineBookingRequestTag?offlineBookingRequestID='+offlineBookingRequestID+'&offlineBookingRequestStatus='+offlineBookingRequestStatus).pipe(map((data) => {
      return data;
    }), catchError(this.handleError));
    //error => { return throwError(error)}
  }
}
